import { render, staticRenderFns } from "./DeliveryListItem.vue?vue&type=template&id=1da3d3e4"
import script from "./DeliveryListItem.vue?vue&type=script&lang=js"
export * from "./DeliveryListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports